// src/hooks/useCatalogs.js
import { useAppContext } from '../components/context/AppContext';

/**
 * Global state hook for category options and catalogs management
 * Connects to AppContext for centralized state management
 */
export const useCatalogs = () => {
    const { state, actions } = useAppContext();

    // Global state from AppContext
    const categoryOptions = state.categoryOptions || [];
    const isLoading = state.loading;
    const error = state.error;

    return {
        // State
        categoryOptions,
        isLoading,
        error,
        
        // Actions (maintain same function signatures for backward compatibility)
        createCategory: actions.createCategory,
        updateCategory: actions.updateCategory,
        deleteCategory: actions.deleteCategory,
        createCatalog: actions.createCatalog,
        fetchCategoryOptions: actions.fetchCategoryOptions,

        // Utility functions (preserved from original implementation)
        getCategoryOptionsById: (catalogId) => {
            const catalog = categoryOptions.find(c => c.id === catalogId);
            return catalog ? catalog.options : [];
        },

        getCatalogById: (catalogId) => {
            return categoryOptions.find(catalog => catalog.id === catalogId);
        },

        getCategoriesByCatalogId: (catalogId) => {
            const catalog = categoryOptions.find(cat => cat.id === catalogId);
            return catalog ? catalog.options : [];
        },

        getCategoryById: (catalogId, categoryId) => {
            const catalog = categoryOptions.find(cat => cat.id === catalogId);
            if (!catalog) return null;
            return catalog.options.find(option => option.id === categoryId);
        },

        getAllCategories: () => {
            return categoryOptions.flatMap(catalog => 
                catalog.options.map(option => ({
                    ...option,
                    catalogId: catalog.id
                }))
            );
        },

        getCatalogCount: () => categoryOptions.length,

        getTotalCategoryCount: () => {
            return categoryOptions.reduce((total, catalog) => 
                total + (catalog.options ? catalog.options.length : 0), 0
            );
        }
    };
};